import { connect } from 'react-redux';

import Users from 'endpoints/users';
import Data from 'endpoints/data';
import { loadUsers } from 'app/action-creators';
import { dataActions } from 'app/actions';
import Layout from 'components/layout';
import Wait from 'components/wait';

import List from './list';
import Form from './form';

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: true };
  }

  componentDidMount() {
    Promise.all([Users.getList(), Data.getUserRoles(), Data.getUserCountries()]).then(([users, roles, countries]) => {
      this.props.loadUsers(users);
      this.props.setUserRoles(roles);
      this.props.setUserCountries(countries.map(item => ({ value: item.code, label: item.name })));
      this.setState({ isLoading: false });
    })
  }

  render() {
    const { users, match, currentUser } = this.props;

    if (!this.state.isLoading) {
      if (match.params.id === undefined) {
        return (
          <Layout>
            <List
              users={users}
              currentUser={currentUser}
              history={this.props.history}
            />
          </Layout>
        );
      } else {
        return (
          <Layout>
            <Form
              users={users}
              id={match.params.id}
              currentUser={currentUser}
              history={this.props.history}
            />
          </Layout>
        );
      }
    }

    return <Layout><Wait /></Layout>
  }
}

const mapStateToProps = state => ({ users: state.data.users, currentUser: state.auth.user });

export default connect(mapStateToProps, { 
  loadUsers, 
  setUserRoles: dataActions.setUserRoles, 
  setUserCountries: dataActions.setUserCountries 
})(Index);
